import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { V2SignupService } from './v2-signup.service';

function isPartnerApi(url: string): boolean {
  return url.includes('partner-api-');
}

@Injectable()
export class V2SignupInterceptor implements HttpInterceptor {
  constructor(private v2SignupService: V2SignupService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.v2SignupService.enabled && isPartnerApi(req.url)) {
      const cloned = req.clone({
        headers: req.headers.set('X-V2-Signup', 'true'),
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
